module.exports = __webpack_public_path__ + "static/media/greenhouse2Step8-3.87bdc2fd.jpg";